import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propId, } from '../../../../../../../helpers/custom-prop-types';
import RfpOneBackLink from '../Link/RfpOneBackLink';
import RfpOneNextLink from '../Link/RfpOneNextLink';
import RfpOnePrevLink from '../Link/RfpOnePrevLink';
const RfpOneFooterNavSp = (props) => {
    const { id, isPreview, nextViewRequestId, prevViewRequestId } = props;
    return (_jsxs("div", Object.assign({ className: 'rfp-footer-nav-sp' }, { children: [_jsx("div", Object.assign({ className: 'prev_column' }, { children: prevViewRequestId && (_jsx(RfpOnePrevLink, { id: id, viewRequestId: prevViewRequestId })) })), _jsx("div", Object.assign({ className: 'back_column' }, { children: _jsx(RfpOneBackLink, { id: id, isPreview: isPreview }) })), _jsx("div", Object.assign({ className: 'next_column' }, { children: nextViewRequestId && (_jsx(RfpOneNextLink, { id: id, viewRequestId: nextViewRequestId })) }))] })));
};
RfpOneFooterNavSp.propTypes = {
    id: propId().isRequired,
    isPreview: propBool().isRequired,
    nextViewRequestId: propId(),
    prevViewRequestId: propId(),
};
RfpOneFooterNavSp.defaultProps = {
    nextViewRequestId: null,
    prevViewRequestId: null,
};
export default RfpOneFooterNavSp;
